import {
    FETCH_SUBJECTS,
    NEW_SUBJECT
} from '../actions/types';

const initialState = {
    items: [],
    item: {}
}

export default function(state=initialState, action) {
    switch(action.type) {
        case FETCH_SUBJECTS:
            return {
                ...state,
                items: action.payload
            }
        case NEW_SUBJECT:
            return {
                ...state,
                item: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/subjectReducer.js